import { Button, Stack, Typography } from '@mui/material';
import { AtLocator } from '@Components/shared/locators/AtLocator';
import { useLocalization } from '@Modal/hooks/localization/useLocalization';
import { ChangeEvent } from 'react';
import { useAuthorization } from '@Modal/hooks/authorization/useAuthorization';

export const LocalizationsTitle: React.FC = () => {
  const { userPermissions, currentUser } = useAuthorization();

  const {
    handleExportLocalizations,
    uploadLocalizations,
    handleCreateLocalizationKeyDialog,
    handleShowCreateLanguageDialog,
  } = useLocalization();

  const handleFileUpload = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e?.target?.files?.[0];
    if (file) uploadLocalizations(file);
  };

  const canViewLocalizations =
    userPermissions?.includes('CAN_VIEW_LOCALIZATIONS') || currentUser?.isSuper;

  const canManageLocalizations =
    userPermissions?.includes('CAN_MANAGE_LOCALIZATIONS') || currentUser?.isSuper;

  return (
    <AtLocator type="container" name="CampaignsTitle">
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ paddingBottom: 2 }}
      >
        <Typography variant="h3">Game Language</Typography>
        <Stack direction="row" alignItems="center" gap={2}>
          {canManageLocalizations && (
            <>
              <Button variant="outlined" onClick={() => handleShowCreateLanguageDialog(true)}>
                Create New Language
              </Button>
              <Button variant="outlined" onClick={() => handleCreateLocalizationKeyDialog(true)}>
                Create Language Key
              </Button>
            </>
          )}
          {canViewLocalizations && (
            <Button variant="outlined" onClick={handleExportLocalizations}>
              Export Languages
            </Button>
          )}
          {canManageLocalizations && (
            <label htmlFor="upload-file">
              <input
                id="upload-file"
                type="file"
                accept=".xlsx,.xls"
                onChange={handleFileUpload}
                style={{ display: 'none' }}
              />
              <Button variant="outlined" component="span">
                Import
              </Button>
            </label>
          )}
        </Stack>
      </Stack>
    </AtLocator>
  );
};
